// extracted by mini-css-extract-plugin
export var actions = "_ui-4";
export var item = "_ui-1";
export var price = "_ui-3";
export var quantity = "_ui-2";
export var table = "_ui-0";